<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Edit The Business Banner Image"
      id="owner_view_banner_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="edit_banner_image_form_ref"
      id="edit_banner_image_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
        <ImageField
            label="Select a Business Banner"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="businessbanners"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="edit_banner_file_uploader"
            :required="false"
            empty_file_error="No  image choosen for the banner"
            :default_value="default_banner"
          >
          </ImageField>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import ImageField from "../../../components/ImageField";
export default {
  name: "OwnerBusinessesEditBanner",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    ImageField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      default_banner: Utils.default_business_banner,
      banner: "",
    };
  },
  methods: {
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_banner_image_form_ref.show_error_dialog();
        }
      );
    },
    on_auto_fill() {
      this.init_form();
    },
    init_form() {
      this.default_banner = this.business.banner;
      this.banner = this.business.banner;
      this.errors = [];
      this.message = "";
    },
    submit() {
      //upload the logo
      this.$refs.edit_banner_file_uploader.upload_file();
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.banner = file_url;
      this.update_business();
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.edit_banner_image_form_ref.show_error_dialog();
    },
    on_hide_message() {
        this.load_business(this.business_id);
    },
    update_business() {
      this.errors = [];
      this.message = "";
  
      ServerClient.Businesses.update_business_banner(
        {
          banner: this.banner,
          id: this.business_id
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_banner_image_form_ref.on_clear_form();
          this.message =
            "<b>Operation was successfull</b> <br/>  Your Business banner was updated successfully";
          this.$refs.edit_banner_image_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_banner_image_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
       

    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Edit Banner",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Banner",
          disabled: true,
          href:
            "/owner/businesses/list/view/" + this.business_id + "/edit_banner",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_banner_edit_form", options);
  },
};
</script>